module.exports = __webpack_public_path__ + "static/media/017.f9874f38.jpg";